import { render, staticRenderFns } from "./submitPrompt.vue?vue&type=template&id=29ecb60f&scoped=true&"
import script from "./submitPrompt.vue?vue&type=script&lang=js&"
export * from "./submitPrompt.vue?vue&type=script&lang=js&"
import style0 from "./submitPrompt.vue?vue&type=style&index=0&id=29ecb60f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ecb60f",
  null
  
)

export default component.exports